import dayjs, { Dayjs } from "dayjs";

export const getStartOfDecade = (year?: Dayjs): Dayjs => {
  const yearOrDefault = year ?? dayjs();
  return yearOrDefault.subtract(yearOrDefault.year() % 10, "years");
};

export const getEndOfDecade = (year?: Dayjs): Dayjs =>
  getStartOfDecade(year).add(9, "years");
